import { FunctionComponent } from 'react';
import { Button, Text, Textinput } from '@/atoms';
import { ButtonVariant } from '@/atoms/button/types';
import { Tick } from '@/icons';
import { Form, Formik } from 'formik';
import toast, { Toaster } from 'react-hot-toast';
import { debug } from 'util';
import { object, string } from 'yup';
import { TypeResetFormEmailProps } from './types';

export const ResetFormEmail: FunctionComponent<TypeResetFormEmailProps> = ({
  className = '',
  title,
  description,
  emailLabel,
  textButton,
  backgroundColor,
}: TypeResetFormEmailProps) => {
  const RegisterSchema = object().shape({
    email: string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long')
      .required('El email es obligatorio'),
  });

  const initialValues: TypeResetFormEmailProps = {
    backgroundColor: '',
    title: '',
    textButton: '',
    emailLabel: '',
    email: '',
  };

  const success = () =>
    toast('Recibirá un email con los pasos a seguir.', {
      icon: (
        <Tick
          width={64}
          color="#fff"
          className="p-3 rounded-full bg-status-success font-bold"
        />
      ),
      duration: 6000,
      style: {
        background: '#575757',
        padding: '16px',
        fontWeight: 'bold',
        marginBottom: '80px',
        color: '#fff',
      },
    });

  // const success = () =>
  //   toast('La contraseña se ha cambiado correctamente.', {
  //     icon: (
  //       <Tick
  //         width={64}
  //         color="#fff"
  //         className="p-3 rounded-full bg-status-success font-bold"
  //       />
  //     ),
  //     duration: 2000,
  //     style: {
  //       background: '#575757',
  //       padding: '16px',
  //       fontWeight: 'bold',
  //       marginBottom: '80px',
  //       color: '#fff',
  //     },
  //   });

  return (
    <div
      style={{ backgroundColor: backgroundColor }}
      className={`flex flex-col ${className}`}
    >
      <Text className="text-subtitle text-subtitle--l mb-6">{title}</Text>
      {description && (
        <Text className="text-body text-body--m mb-6">{description}</Text>
      )}
      <Formik
        onSubmit={async (res) => {
          const response = await fetch('/api/shopify/customer/request', {
            method: 'POST',
            headers: {
              Accept: 'application.json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email: res.email,
            }),
            cache: 'default',
          });
          await response.json();
          success();
          debug('submitted');
        }}
        validationSchema={RegisterSchema}
        initialValues={initialValues}
      >
        <Form noValidate>
          <div className="flex flex-wrap justify-between">
            <Textinput
              label={emailLabel}
              name="email"
              type="email"
              className="mb-2 w-full md:min-w-[300px]"
              placeholder="ejemplo@gmail.com"
            />

            <div>
              <Button variant={ButtonVariant.PRIMARY}>{textButton}</Button>
            </div>

            <Toaster
              position="bottom-center"
              containerStyle={{ position: 'absolute' }}
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
};

ResetFormEmail.displayName = 'ResetFormEmail';
